export const environment = {
  production: false,
  apiUrl: 'https://sabiq-backend-qa.azurewebsites.net/api'
};
